// User Model
import { Model } from '@vuex-orm/core'

export default class ContractType extends Model {
    static entity = 'contract-types';

    static fields() {
        return {
            id: this.attr(null),
            identifier: this.attr(null),
            brand_id: this.number(0),
            name: this.string(''),
            description: this.string(''),
            reward: this.number(0),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }
}
